import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDT } from "@/lib/qr";

function Row({ x, me, kind }) {
  const title = kind === "visits" ? x.business_name : kind === "visitors" ? x.user_name : kind === "redeemed" ? `${x.user_name} · ${x.offer_name}`
    : kind === "offers" ? `${x.offer_name} · ${x.business_name}` : x.user_id === me ? `Te ${x.to_user_name}` : `Nga ${x.user_name}`;
  const pts = kind === "transfers" && x.user_id === me ? -x.points : kind === "redeemed" ? null : x.points;
  return (
    <div className="bg-white rounded-2xl p-3 flex items-center gap-3 border border-slate-100" data-testid={`qrh-${kind}-${x.tx_id}`}>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-slate-800 break-words" translate="no">{title}</div>
        <div className="text-[11px] text-slate-400">{fmtDT(x.created_at)} · ID {x.tx_id}{x.note ? ` · ${x.note}` : ""}</div>
      </div>
      {pts != null && pts !== 0 && <b className={pts > 0 ? "text-emerald-600" : "text-rose-500"}>{pts > 0 ? "+" : ""}{pts}</b>}
    </div>
  );
}

export function QrHistory({ me, business }) {
  const [d, setD] = useState(null);
  const [tab, setTab] = useState("visits");
  useEffect(() => { api.get("/qr/history").then((r) => setD(r.data)).catch(() => setD({})); }, []);
  const tabs = [["visits", "Vizitat"], ["transfers", "GjejKredit"], ["offers", "Ofertat"], ...(business ? [["visitors", "Vizitorët"], ["redeemed", "Përdorur te ne"]] : [])];
  if (!d) return <p className="text-center text-sm text-slate-400 py-6">Duke ngarkuar...</p>;
  const list = d[tab] || [];
  return (
    <div data-testid="qr-history">
      <div className="flex gap-1.5 overflow-x-auto pb-1">
        {tabs.map(([k, l]) => <button key={k} data-testid={`qrh-tab-${k}`} onClick={() => setTab(k)} className={`shrink-0 h-9 px-3 rounded-full text-xs font-bold ${tab === k ? "bg-emerald-500 text-white" : "bg-white text-slate-600 border border-slate-200"}`}>{l}</button>)}
      </div>
      <div className="mt-2 space-y-2">
        {list.length ? list.map((x) => <Row key={x.tx_id} x={x} me={me} kind={tab} />) : <p className="text-center text-sm text-slate-400 py-6" data-testid="qrh-empty">Asgjë ende.</p>}
      </div>
    </div>
  );
}
